export default __webpack_public_path__ + "static/media/gournay15.f2311c3c.jpg";